export default "__VITE_ASSET__3172425f__"